import { ResponseLogItem } from '@core/modules/response-logger/response-logger.type';

export class ResponseLoggerStateModel {
  responsesLog: ResponseLogItem[] = [];
}
